import { Component, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { CompaniesEnum } from 'app/core/enums/companies.enum';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { ExcludeProviderService } from '../../exclude-providers.service';

@Component({
  selector: 'app-exclude-providers',
  templateUrl: './exclude-providers.component.html',
  styleUrls: ['./exclude-providers.component.scss']
})
export class ExcludeProvidersComponent implements OnInit, OnDestroy {

  @Output() callBackExcludeProvider = new EventEmitter<{ hasClose: boolean }>();
  providerId = 0;
  objForm: FormGroup;
  private arraySubscriptions = [];

  get dataDualListBox(): AbstractControl {
    return this.objForm.get('objectData');
  }

  get riderIdCrl(): AbstractControl {
    return this.objForm.get('riderId');
  }

  constructor(
    private fb: FormBuilder,
    readonly objExcludeProviderService: ExcludeProviderService,
    private sweetAlertHelper: SweetAlertHelper,
    private _loadingT2: T2LoadingService,
    protected newReservationService: ReservationService
  ) {
    this.objForm = this.fbGroup();
    this.subscriptions();
  }

  ngOnInit(): void {
  }

  private fbGroup(): FormGroup {
    return this.fb.group({
      riderId: null,
      objectData: [null]
    });
  }

  getDataDualListBox(riderId: number): void {
    this.objExcludeProviderService.getExcludeProviderListByRider(riderId)
    .subscribe({
      next: (res: { providerlist: any[], excludeproviderlist: any[] }) => {
        let PROVIDER_LIST = [];
        let EXCLUDE_PROVIDER_LIST = [];

        if (res.providerlist && res.providerlist.length) {
          PROVIDER_LIST = res.providerlist.map( row => {
            return {id: row.companyid, description: row.description };
          });
        }

        if (res.excludeproviderlist && res.excludeproviderlist.length) {
          EXCLUDE_PROVIDER_LIST = res.excludeproviderlist.map( row => {
            return {id: row.companyid, description: row.description };
          });
        }

        if (this.providerId > 0) {
          this.dataDualListBox.patchValue({
            disabledItemList: [this.providerId, CompaniesEnum.None],
            excludeProviderList: EXCLUDE_PROVIDER_LIST,
            providerList: PROVIDER_LIST
          });
        } else {
          this.dataDualListBox.patchValue({
            disabledItemList: [null, CompaniesEnum.None],
            excludeProviderList: EXCLUDE_PROVIDER_LIST,
            providerList: PROVIDER_LIST
          });
        }
      },
      error: (error: any) => this.sweetAlertHelper.captureException(error)
    });
  }

  private save(list: number[]): void {
    this._loadingT2.show('Saving Rider Exclude Provider List...');
    const BODY = {
      riderid: this.riderIdCrl.value,
      providerlist: list
    };

    this.objExcludeProviderService.saveExcludeProviderbyRider(BODY)
    .subscribe({
      next: (res: any) => {
        this._loadingT2.hiden();
        this.sweetAlertHelper
        .createCustomAlert({
          title: 'Success',
          text: res.message,
          type: 'success',
        })
        .then(() => {
          this.callBackExcludeProvider.emit({ hasClose: true });
        });
      },
      error: (error: any) => {
        this._loadingT2.hiden();
        this.sweetAlertHelper.captureException(error);
      }
    });
  }

  private subscriptions(): void {
    this.arraySubscriptions.push(
      this.newReservationService.riderSelectedObs$.subscribe({
        next: (res) => {
          if (res !== null) {
            this.riderIdCrl.patchValue(res.id);
            this.getDataDualListBox(res.id);
          }
        }
      })
    );

    this.arraySubscriptions.push(
      this.newReservationService.providerSelectedObs$.subscribe({
        next: (res) => {
          if (res !== null && res.id > 0) {
            this.providerId = res.id;

            if (this.dataDualListBox.value !== null) {
              this.dataDualListBox.patchValue({
                disabledItemList: [res.id, CompaniesEnum.None],
                providerList: this.dataDualListBox.value.providerList,
                excludeProviderList: this.dataDualListBox.value.excludeProviderList,
              });
            }
          } else {
            if (this.dataDualListBox.value !== null) {
              this.dataDualListBox.patchValue({
                disabledItemList: [null, CompaniesEnum.None],
                providerList: this.dataDualListBox.value.providerList,
                excludeProviderList: this.dataDualListBox.value.excludeProviderList,
              });
            }
          }
        }
      })
    );

    this.arraySubscriptions.push(
      this.dataDualListBox.valueChanges.subscribe({
        next: (res: any) => {
          if (res.sendData) {
            this.save(res.leftList.map((row: any) => row.datasetvaluefield));
          }
        },
        error: (error: any) => this.sweetAlertHelper.captureException(error)
      })
    );
  }


  ngOnDestroy(): void {
    if (!!this.arraySubscriptions) {
      this.arraySubscriptions.forEach(value => value.unsubscribe());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/exclude-providers/components/exclude-providers/exclude-providers.component.ts